define(
    'viewmodels/secured/explorer/details/tabs/actions/SaveNewVersionAction',[
        'viewmodels/secured/explorer/details/tabs/actions/Action',
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (Action, dialogService, documentsService, i19n) {

        var SaveNewVersionAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.savenewversion,
                    message: i19n.to.savenewversionofdocument
                }
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-file-text-o", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                documentsService.actions.canSaveNewVersion(action.context.checkedDocuments())
                    .done(function(result) {
                        var promise;

                        if (!result.success) 
                            promise = dialogService.showDocumentActionErrorDialog(result);
                        else 
                            promise = dialogService.showMessageBox("TODO: Implement this action.", "TODO: Add Title", [{ label: "Ok", message: "" }]);

                        promise.then(complete);
                    });
            }

            return _Action;

        })(Action);

        return SaveNewVersionAction;
        
    });
